// Shared receipt printer: opens a new window with the SAME styled receipt used in POS.
// Usage: printReceipt(bill, shop, containerId = "receipt-preview-container")
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export async function downloadReceiptPdf(bill, containerId = "receipt-preview-container") {
  const container = document.getElementById(containerId);
  if (!container) {
    alert("Receipt preview not found. Open the bill view first.");
    return;
  }
  const node = container.querySelector(".printable") || container;
  try {
    await new Promise((r) => setTimeout(r, 150));
    const canvas = await html2canvas(node, {
      scale: 2, backgroundColor: "#ffffff", useCORS: true, allowTaint: true, logging: false,
    });
    const imgData = canvas.toDataURL("image/png");
    const widthMm = 80;
    const heightMm = (canvas.height * widthMm) / canvas.width;
    const pdf = new jsPDF({ unit: "mm", format: [widthMm, heightMm] });
    pdf.addImage(imgData, "PNG", 0, 0, widthMm, heightMm);
    pdf.save(`Bill-${(bill.bill_no || "receipt").replace(/[/]/g, "-")}.pdf`);
  } catch (e) {
    alert("PDF generation failed: " + (e?.message || "unknown error"));
  }
}

export function printReceipt(bill, shop, containerId = "receipt-preview-container") {
  const container = document.getElementById(containerId);
  if (!container) {
    alert("Receipt preview not mounted. Open the bill preview first.");
    return;
  }
  const clone = container.cloneNode(true);
  const liveCanvases = container.querySelectorAll("canvas");
  const cloneCanvases = clone.querySelectorAll("canvas");
  liveCanvases.forEach((c, i) => {
    try {
      const img = document.createElement("img");
      img.src = c.toDataURL("image/png");
      img.style.width = c.style.width || c.width + "px";
      img.style.height = c.style.height || c.height + "px";
      cloneCanvases[i].replaceWith(img);
    } catch (_) { /* ignore */ }
  });
  const html = clone.innerHTML;
  const w = window.open("", "_blank", "width=400,height=700");
  if (!w) {
    alert("Please allow popups for this site to print bills.");
    return;
  }
  w.document.write(`<!doctype html><html><head>
<title>Bill ${bill.bill_no}</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@500;600;700;800&family=Manrope:wght@600;700;800&display=swap" rel="stylesheet">
<style>
  @page { size: 80mm auto; margin: 0; }
  *,*::before,*::after { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; background: white; font-family: 'IBM Plex Mono', monospace; color: black; font-size: 14px; font-weight: 700; line-height: 1.3; }
  body { padding: 0; width: 80mm; }
  .border { border: 1.5px solid black; border-radius: 4px; padding: 6px; }
  .border-2 { border: 1.5px solid black; border-radius: 4px; padding: 6px; }
  table { width: 100%; border-collapse: collapse; }
  th, td { padding: 1px 0; }
  .text-center { text-align: center; }
  .text-right { text-align: right; }
  .text-left { text-align: left; }
  b, th, .font-bold { font-weight: 800 !important; }
  .font-heading { font-family: 'Manrope', sans-serif; font-weight: 800; letter-spacing: -0.01em; }
  .text-2xl { font-size: 22px; font-weight: 800; }
  .text-lg { font-size: 16px; }
  .text-xs { font-size: 12px; font-weight: 700; }
  .text-\\[10px\\] { font-size: 11px; font-weight: 700; }
  .text-\\[11px\\] { font-size: 12px; font-weight: 700; }
  .dashed-divider { border-top: 1.8px dashed #000; margin: 4px 0; }
  .grid { display: grid; }
  .grid-cols-2 { grid-template-columns: 1fr 1fr; gap: 6px; }
  .flex { display: flex; }
  .flex-col { flex-direction: column; }
  .items-center { align-items: center; }
  .justify-between { justify-content: space-between; }
  .justify-center { justify-content: center; }
  .gap-2 { gap: 6px; }
  .my-2 { margin: 4px 0; }
  .mt-1 { margin-top: 2px; }
  .mt-2 { margin-top: 4px; }
  .mb-1 { margin-bottom: 2px; }
  .py-1 { padding: 1px 0; }
  .py-2 { padding: 4px 0; }
  .px-1 { padding: 0 2px; }
  .p-2 { padding: 4px; }
  .p-3 { padding: 6px; }
  .rounded { border-radius: 3px; }
  .space-y-1 > * + * { margin-top: 2px; }
  img { display: inline-block; }
</style>
</head><body>${html}<script>
setTimeout(() => { window.focus(); window.print(); }, 300);
window.onafterprint = () => window.close();
</script></body></html>`);
  w.document.close();
}
